var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.$tc('model.resource.label', 2)))]),_c('BookshelfDisplay',{attrs:{"value":_vm.context.survey.bookshelf}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }